import React from 'react';
import LocationAndAge from 'app/components/customer/Registration/Parts/LocationAndAge';

const Step1 = ({ initialValues, onSubmit, experimentVariant }) => {
  return <LocationAndAge experimentVariant={experimentVariant} initialValues={initialValues} onSubmit={onSubmit} />;
};

export default Step1;
